<template>

    <m-edit1/>

    <m-single-product-501 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false,"showSpecifiedFeature":"","showVariationProductImage":false,"mapFeatureName":null,"variationProductComponent":"VariationSelection1","showLatestProductUpdate":true,"showLatestProductUpdateReal":false,"showDescription":true,"showFeatures":true,"showComments":true,"swiperPerViewSM":1.2,"swiperPerViewMD":2.2,"swiperPerViewLG":4},...{}}' :style='""' class="my-3 container" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                </m-single-product-501>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleProduct501 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct501'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleProduct501,mDiv },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
